// stores/useDocumentModalStore.ts
import { create } from "zustand";

interface DocumentModalState {
  documentPopoverId: string | null;
  isDeleteOpen: boolean;
  isRecategorizeOpen: boolean;
  isDocumentActionsOpen: boolean;
  setDocumentPopoverId: (docId: string | null) => void;
  openDelete: () => void;
  closeDelete: () => void;
  openRecategorize: () => void;
  closeRecategorize: () => void;
  openDocumentActions: () => void;
  closeDocumentActions: () => void;
}

export const useDocumentModalStore = create<DocumentModalState>((set) => ({
  documentPopoverId: null,
  isDeleteOpen: false,
  isRecategorizeOpen: false,
  isDocumentActionsOpen: false,
  setDocumentPopoverId: (docId: string | null) =>
    set({ documentPopoverId: docId }),
  openDelete: () => set({ isDeleteOpen: true }),
  closeDelete: () => set({ isDeleteOpen: false }),
  openRecategorize: () => set({ isRecategorizeOpen: true }),
  closeRecategorize: () => set({ isRecategorizeOpen: false }),
  openDocumentActions: () => set({ isDocumentActionsOpen: true }),
  closeDocumentActions: () => set({ isDocumentActionsOpen: false }),
}));
